import {computed} from "vue";
import {SettingStore} from "@/store/modules/setting";
import {EnumTheme} from "@/enum/theme";

/**
 * 登入者資訊
 */

export const useSetting = () => {

    /**
     * 用戶 store
     */
    const settingStore = SettingStore()

    /**
     * 是否為深色主題
     */
    const isDarkTheme = computed(() => {
        return settingStore.isDarkTheme
    })

    /**
     *  切換主體
     */
    const setTheme = async (value) => {
        settingStore.setTheme(value)
        const body = document.getElementsByTagName("BODY")[0];
        //切換的時候, 加入一個暫時關閉 .form-control transition的功能
        //不然切換的時候會閃一下很醜
        body.classList.add("pv")
        value === EnumTheme.DARK ? body.classList.add("dark-layout") : body.classList.remove("dark-layout")
        setTimeout(()=>{
            //完成後在去掉暫時transition的功能
            body.classList.remove("pv")
        }, 50)
    }

    /**
     * 獲取 - 用戶 - 個人設定
     */
    const getSetting = computed(() => {
        return settingStore.getAll
    })

    /**
     * 更新 - 用戶 - 個人設定 - 列表 - 開啟模式
     */
    const setSettingEntriesEdit = (
        e
    ) => settingStore.setEntriesEdit(e)

    /**
     * 更新 - 用戶 - 個人設定 - 認證方式
     */
    const setSettingAuthorized = (
        e
    ) => settingStore.setAuthorized(e)


    return {
        isDarkTheme,
        setTheme,
        getSetting,
        setSettingEntriesEdit,
        setSettingAuthorized
    }

}
